export const fwkConst = {
    NEW_ADJUST_URL: "rmej7yso",//新的adjust跳转链接

    ADJUST_ATTR: "ADJUST_ATTR",//adjust的归因储存

    WEB_UUID: "WEB_UUID",//
    H5_UUID: "H5_UUID",

    PWA_STATUS: "PWA_STATUS",//PWA的安装状态

    SM_BROWSER_ID: "n0xiofzt",
    SM_ID: "SM_ID",
    SM_SESSION_ID: "ofvxtofw",

    GEO_LOCATION_DECRYPT: "g0e00e34v",//GEO解密返回结果
    GEO_ISREADY: "g0e00e34vs",

    guide_install_count: "dci7ad5w",//引导显示次数
}
